import {AfterViewInit, Component, OnInit, HostListener} from '@angular/core';
import { HomeComponentModel } from './home.component.model';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { ApplicationStateService } from '../application-state.service';
import {HomeComponent} from './home.component';
import * as $ from 'jquery';
import Skrollr from '../../assets/javascripts/skrollr/dist/skrollr.min';
import { faArrowLeft, faEnvelope, faLocationArrow, faBullhorn, faChevronLeft, faChevronRight, faCopyright, faTimes } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';

@Component({
    selector:    'app-home-desktop',
    templateUrl: './home.component.desktop.html',
    styleUrls:   ['./home.component.desktop.sass']
})
export class HomeComponentDesktop extends HomeComponent implements AfterViewInit, OnInit {

    constructor(router: Router, sanitizer: DomSanitizer, applicationStateService: ApplicationStateService) {
        super(router, sanitizer, applicationStateService);
        this.add_text_sucess_cases();
        for (let i = 1; i < 9; i++) {
            this.success_cases.push('assets/images/success cases/graffigna-casos-exito-' + i + '.jpg');
        }
        for (let i = 1; i < 37; i++) {
            this.carousel_img.push('assets/images/client logos/graffigna-' + i + '.png');
        }
        for (let i = 1; i < 10; i++) {
            this.table_service_1.push("assets/images/services/1-Branding/graffigna-" + i + "-Branding.jpg");
            this.table_service_2.push("assets/images/services/2-TIC/graffigna-" + i + "-TIC.png");
            this.table_service_3.push("assets/images/services/3-Social-Media/graffigna-" + i + "-Social-Media.jpg");
            this.table_service_4.push("assets/images/services/4-Endo-Marketing/graffigna-" + i + "-Endo.jpg");
        }
        for (let i = 1; i < 5; i++) {
            this.table_service_5.push("assets/images/services/5-Crm-Marketing/graffigna-" + i + "-Crm.png");
            this.table_service_6.push("assets/images/services/6-Apps/graffigna-app-" + i + ".png");
        }
    }
    faCopyright = faCopyright;
    faTimes = faTimes;
    fafacebook = faFacebook;
    fainstagram = faInstagram;
    faemail = faEnvelope;
    farrowleft = faArrowLeft;
    falocationarrow = faLocationArrow;
    fabullhorn = faBullhorn;
    faChevronLeft = faChevronLeft;
    faChevronRight = faChevronRight;
    images = [];
    imgServiceModal;
    carousel_img = [];
    success_cases = [];
    tic_urls = ['https://aretibank.com/', 'https://cafegavi.com/', 'https://elguayacan.com/', 'http://productoslalocura.com/', 'https://leaseback.com/', 'https://www.medicacolombia.com/', 'https://www.doggostreats.com/', 'https://www.sell2rent.com/', 'https://zelltor.com/'];
    text_Success_cases = [];
    title_success_cases;
    paragraph_success_cases_1;
    paragraph_success_cases_2;
    table_service_1 = [];
    table_service_2 = [];
    table_service_3 = [];
    table_service_4 = [];
    table_service_5 = [];
    table_service_6 = [];

    @HostListener('window:resize', ['$event'])
    public sizeChange(event) {
        console.log("entro" + window.innerHeight);
        if($(window).width() <= 1025){
            location.reload();

        }
        if(window.innerHeight < 600){
            location.reload();

        }
    }

    skroll = Skrollr.init({
        constants: {
            section2: 2398 - screen.height
        }
    }
    );

    // Carousel
    title = 'ngSlick';

    slideConfig = {
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        infinite: true,
        arrows: false,
        centerMode: true,
        centerPadding: '1px'
    };

    slideConfig_2 = {
        slidesToShow: 7,
        slidesToScroll: 1,
        dots: false,
        infinite: true,
        arrows: true,
        centerMode: true,
        centerPadding: '10px',
        autoplay: true,
        nextArrow: "<div class='nav-btn next-slide'></div>",
        prevArrow: "<div class='nav-btn prev-slide'></div>"
    };

    ngOnInit(): void {
        this.skroll.refresh();
    }

    ngAfterViewInit() {
        $(function afterViewInit() {
            $('#navbar').removeAttr('data-bottom-top');
            $('#navbar').removeAttr('data-96-top');
            $('#navbar').removeAttr('data-anchor-target');
            $('#navbar').removeAttr('style');
            $('#navbarbutton').removeAttr('data-bottom-top');
            $('#navbarbutton').removeAttr('data-96-top');
            $('#navbarbutton').removeAttr('style');
            $('#navbarbutton').removeAttr('data-anchor-target');
            $('#navbar').addClass('navbarbackground');
        });
    }

    public add_text_sucess_cases() {
        this.text_Success_cases = [["La Locura", "Después de 30 años La Locura decidió implementar un cambio profundo de marca, dándonos el honor de acompañarlos en el lanzamiento y posicionamiento de esta nueva era de la compañía. En el proceso se desarrolló una nueva manera de comunicar la marca y los productos, así como también se hizo énfasis en el cambio de imagen en todos los puntos y en todo su ecosistema digital.", "Después de 30 años La Locura decidió implementar un cambio profundo de marca, dándonos el honor de acompañarlos en el lanzamiento y posicionamiento de esta nueva era de la compañía. En el proceso se desarrolló una nueva manera de comunicar la marca y los productos, así como también se hizo énfasis en el cambio de imagen en todos los puntos y en todo su ecosistema digital."], ["Médica Colombia", "Médica Colombia es una de las empresas especializadas en Home Care más grande del Suroccidente colombiano. Después de 20 años deciden hacer un proceso de renovación de marca, y desde ese momento comenzamos a caminar junto con todo el equipo de esta empresa.", "En todo este tiempo de acompañarlos lanzamos su nueva marca, renovamos toda su comunicación corporativa, intervenimos la decoración de interiores de sus oficinas, desarrollamos todo su ecosistema digital ampliando su alcance de B2B a B2C e implementando sistemas operativos empresariales integrados, desarrollamos una escuela virtual de vida, hacemos endomarketing, creamos y mantenemos sus canales de comunicación en Social Media, hacemos ATL, BTL y asesoramos en la relación con el cliente, pero sobre todas las cosas entendimos la importancia de ser parte de una familia que cuida familias."], ["Banano Network", "Banano Network es una empresa que cuenta con unidades de negocio muy variadas como el turismo, el BTL, las conexiones empresariales, pero que tiene como común denominador el componente creativo en cada una de sus acciones.","Durante el tiempo que hemos sido parte de esta empresa logramos desarrollar un código comunicacional afín a su marca, así como también en cada uno de los eventos hemos sumado en la creación de los conceptos y el desarrollo creativo. A través de sus redes sociales hemos posicionado los destinos turísticos de Banano Tours y sus experiencias innovadoras con el deporte, pero sobre todas las cosas entendimos que cada rincón del mundo enmarca una belleza particular."] , ["Sell2rent", "En llave con nuestro aliado estratégico en Miami hemos sido parte de la consolidación de Sell2rent, una Start Up especializada en un modelo de negocio de inversión en real estate acompañado de un eficiente leaseback que protege a las familias que están pasando por una situación económica vulnerable.", "En este tiempo hemos desarrollado su comunicación estratégica, así como también varios de los procesos de implementación de software de gestión empresarial, creamos todo su contenido de Social Media y acompañamos los procesos de compra de Ads tanto en redes sociales como Google. Dentro del mismo grupo empresarial desarrollamos Zelltor, escuela virtual especializada en el modelo de negocios, pero sobre todas las cosas entendimos el valor de la solidaridad en cada una de las acciones que emprendemos."], ["Areti Bank", "Areti Bank nace con el fin de ser un banco digital completamente sostenible teniendo como principal premisa la  transparencia en sus inversiones, ya que su gran apuesta es mostrar que se puede elegir la construcción de un mundo mejor.", "En esta fase inicial de la marca hemos desarrollado el look and feel de su contenido, así como también el tono comunicacional. Dentro del proceso trabajamos junto con el equipo creativo en su branding y estamos desarrollando su plataforma web, pero sobre todas las cosas aprendimos que para soñar con un futuro mejor debemos comenzar por cambiar el presente."], ["Porcival ","Porcival es una empresa colombiana que produce y comercializa carne de cerdo, que tiene como componente principal la creencia en la coexistencia respetuosa entre los seres vivos, razón por la cual ha decidido apostarle a una producción consciente en la que velamos por el bienestar de sus animales, el medio ambiente y las comunidades.", "Con la empresa hemos desarrollado todas sus comunicaciones digitales, así como también hemos acompañado su desarrollo de nuevas tecnologías y la implementación de nuevos procesos comerciales tanto en el modelo B2B como el B2C, pero sobre todas las cosas hemos aprendido que la fuerza de un equipo unido puede llegar a lograr grandes metas."], ["Russ Software", "Russ Software es una start up que ha desarrollado un programa especializado en la gestión de costos, siendo un desarrollo de tecnología de alta complejidad, con un énfasis corporativo.", "Con la empresa hemos asesorado en los procesos comerciales, así como también con el UX y el desarrollo de su branding, pero sobre todas las cosas hemos aprendido que para soñar siempre hay que soñar en grande. "], ["Pia Residential", "Pia Residential es una empresa especializada en la inversión en Real Estate en Estados Unidos, teniendo principal eje en sus negocios del sureste del país.", "Con la empresa hemos trabajado todo el desarrollo de su comunicación corporativa y material para la fuerza de ventas, teniendo principal énfasis en su posicionamiento y uso adecuado de su marca, pero sobre todas las cosas hemos aprendido que los sueños se cumplen solo hace falta intentarlo hasta que sea posible. "]];
    }

    public changeparagraph(id: number) {
        for (let i = 0; i < 4; i++) {
            if (i === id) {
                $('#services-img-' + i + ' a img').removeClass('opacity-50');
                $('#services-p-' + i).removeClass('d-none');
                $('#table_service_' + i).removeClass('d-none');
                $('#services-p-' + i + ' p strong').css('color', '#EF3340');
                $('#services-p-' + i + ' p strong').css('font-family', 'FuturaBold');
                $('#services-p-' + i + ' p strong').css('font-size', '23px');
            } else if (i != id) {
                $('#services-img-' + i + ' a img').addClass('opacity-50');
                $('#services-p-' + i).addClass('d-none');
                $('#table_service_' + i).addClass('d-none');
            }
        }
    }

    public imgForServiceModal(url: string, id_success_case: number) {
        this.imgServiceModal = url;
        this.title_success_cases = this.text_Success_cases[id_success_case][0];
        this.paragraph_success_cases_1 = this.text_Success_cases[id_success_case][1];
        this.paragraph_success_cases_2 = this.text_Success_cases[id_success_case][2];
    }
    public restoreToModal() {
        $('#restoreModal').addClass('d-none');
        $.each([0, 1, 2, 3], function( index, value ) {
            $('#' + index).removeClass('d-none');
            $('#' + index).removeClass('col-12 text-center');
            $('#' + index).addClass('col-3 img-modal');
        });
    }

    public modalOurClients(id: number) {
        $('#restoreModal').removeClass('d-none');
        $.each([0, 1, 2, 3], function( index, value ) {
            if (index === id) {
                $('#' + id).removeClass('d-none');
                $('#' + id).addClass('col-12 img-modal text-center');
            } else {
                $('#' + index).removeClass();
                $('#' + index).addClass('col-3 img-modal d-none');
            }
        });
    }

    slickInit(e) {
        console.log('slick initialized');
    }
}
